import { Link } from "react-router-dom";
import { ArrowRight, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";

export const SpaceAccessBar = ({ to, label, note, testId, spaceTo, spaceLabel }) => (
  <div className="bg-slate-900 text-white" data-testid={testId || "space-access-bar"}>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-between gap-3 flex-wrap">
      <span className="text-sm font-medium text-white/90">{note}</span>
      <div className="flex items-center gap-2 flex-wrap">
        {spaceTo && (
          <Button asChild size="sm" variant="outline" className="bg-white/10 border-white/40 text-white hover:bg-white/20">
            <Link to={spaceTo} data-testid={`${testId || "space-access"}-space-btn`}>
              <LogIn size={14} className="mr-1.5" /> {spaceLabel}
            </Link>
          </Button>
        )}
        <Button asChild size="sm" className="btn-shine text-white">
          <Link to={to} data-testid={`${testId || "space-access"}-btn`}>
            {label} <ArrowRight size={14} className="ml-1.5" />
          </Link>
        </Button>
      </div>
    </div>
  </div>
);
